import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { api } from "@/lib/api";
import { companyFinancialsSchema, type CompanyFinancials } from "@/schemas";

const financialsList = z.array(companyFinancialsSchema);

export const financialsKeys = {
  forCompany: (companyId: number) => ["companies", companyId, "financials"] as const,
};

export function useCompanyFinancials(companyId: number | undefined) {
  return useQuery({
    queryKey: companyId ? financialsKeys.forCompany(companyId) : ["financials", "none"],
    enabled: !!companyId,
    queryFn: async (): Promise<CompanyFinancials[]> => {
      const data = await api.get<unknown>(`/companies/${companyId}/financials`);
      return financialsList.parse(data);
    },
  });
}
